import { useEffect, useState } from "react";
import { MapPin } from "lucide-react";
import { Eyebrow } from "@/components/brand/Logo";
import { api } from "@/lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const Card = ({ e, dup }) => (
  <figure className="group w-64 shrink-0 overflow-hidden rounded-2xl border border-lasso-line bg-white sm:w-72" data-testid={dup ? undefined : `showcase-card-${e.id}`} aria-hidden={dup || undefined}>
    <div className="aspect-[16/10] overflow-hidden bg-lasso-tint">
      <img src={`${BACKEND}${e.photo_url}`} alt={dup ? "" : `${e.name} community`} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
    </div>
    <figcaption className="px-4 py-3.5">
      <p className="font-display text-sm font-bold">{e.name}</p>
      <p className="mt-1 flex items-center gap-1 text-xs text-zinc-500"><MapPin className="h-3 w-3 text-lasso-deep" /> {e.city}{e.state ? `, ${e.state}` : ""}</p>
      {e.attribution_required && <p className="mt-1 truncate text-[10px] text-zinc-400">Photo: {e.photo_credit}{e.photo_license ? ` · ${e.photo_license}` : ""}</p>}
    </figcaption>
  </figure>
);

export const ShowcaseStrip = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/showcase").then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (!items.length) return null;
  const duration = `${Math.max(items.length * 5, 30)}s`;
  return (
    <section className="border-y border-lasso-line bg-lasso-paper py-12" data-testid="landing-showcase">
      <div className="mx-auto mb-7 flex max-w-7xl items-end justify-between gap-6 px-6">
        <div>
          <Eyebrow>Our communities</Eyebrow>
          <p className="mt-3 max-w-xl text-sm text-zinc-600 sm:text-base">One standard, {items.length}+ neighborhoods — the places our teams take care of every day.</p>
        </div>
      </div>
      <div className="marquee relative overflow-hidden">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-lasso-paper to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-lasso-paper to-transparent" />
        <div className="marquee-track flex w-max gap-5 px-5" style={{ animationDuration: duration }} data-testid="landing-showcase-track">
          {items.map((e) => <Card key={e.id} e={e} />)}
          {items.map((e) => <Card key={`d-${e.id}`} e={e} dup />)}
        </div>
      </div>
    </section>
  );
};
